(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rehabeshop-product-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-size-guide-open]').forEach((openButton) => {
      if (openButton.dataset.sizeGuideReady === 'true') return;
      const block = openButton.closest('[id^="rehabeshop-size-guide-"]');
      const dialog = block?.querySelector('[data-size-guide-dialog]');
      const closeButton = block?.querySelector('[data-size-guide-close]');
      if (!dialog || !closeButton) return;
      openButton.dataset.sizeGuideReady = 'true';
      openButton.addEventListener('click', () => dialog.showModal());
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
